// Admin user-management calls (superuser JWT required by the backend).
// Drives the Users view: list accounts and assign subscription tiers.
// Tier changes are pushed live to the user's mobile app by the backend
// over /ws/sessions ("tier_changed") — nothing else to do client-side.
import { getJson, patchJson } from './restClient';

export const TIERS = ['free', 'starter', 'pro', 'quant', 'brainer_og'] as const;
export type Tier = (typeof TIERS)[number];

/** Human labels for tier pills / selects. */
export const TIER_LABELS: Record<Tier, string> = {
  free: 'Free',
  starter: 'Starter',
  pro: 'Pro',
  quant: 'Quant',
  brainer_og: 'Brainer OG',
};

export interface AdminUser {
  id: string;
  username: string;
  email: string;
  full_name: string | null;
  role: string;
  tier: Tier;
  is_active: boolean;
  is_superuser: boolean;
  email_verified: boolean;
  created_at: string;
}

/** Page through /users (superuser-only on the backend). */
export function listUsers(skip = 0, limit = 200, signal?: AbortSignal): Promise<AdminUser[]> {
  return getJson<AdminUser[]>(`/users?skip=${skip}&limit=${limit}`, signal);
}

/** Assign a subscription tier. Returns the updated user. */
export function setUserTier(userId: string, tier: Tier): Promise<AdminUser> {
  return patchJson<AdminUser>(`/users/${userId}/tier`, { tier });
}
